










import { Vue, Component } from 'vue-property-decorator';
import Devoluciones from '@/pantallas/Conecta/Devoluciones/Devoluciones.vue';

@Component({
  components: {
    Devoluciones,
  },
})
export default class DevolucionesPantalla extends Vue {}
